import React__default from 'react';
import useKeyPress from './use-key-press.js';

const useIsOpenSuggestions = (inputRef)=>{
    const [isSuggestionsOpen, setIsSuggestionsOpen] = React__default.useState(false);
    const escPress = useKeyPress('Escape', inputRef);
    React__default.useEffect(()=>{
        setIsSuggestionsOpen(false);
    }, [
        escPress
    ]);
    return [
        isSuggestionsOpen,
        setIsSuggestionsOpen
    ];
};
var useIsOpenSuggestions$1 = useIsOpenSuggestions;

export { useIsOpenSuggestions$1 as default };
//# sourceMappingURL=use-is-open-suggestions.js.map
